import { useCMSApiQuery } from './useCMSApiQuery';

export function useSolutionsMenuQuery(locale: string, enabled: boolean) {
  return useCMSApiQuery<SolutionsMenu>(
    `/cms/v1/menu-items?PageType=Solutions&locale=${locale}`,
    undefined,
    { enabled }
  );
}
export type SolutionsMenu = {
  menuitems: Solution[];
  total: number;
};
export type Solution = {
  nodeAliasPath: string;
  nodeGUID: string;
  pageName: string;
  pageSubType: null;
  pageType: string;
  pageUrl: string;
  partialPageUrl: string;
  subMenu: Solution[];
  vendorName: string;
};
